module.exports = __webpack_public_path__ + "img/IMG_1055.117eb4b9.png";